import { Handle, Position } from '@xyflow/react';

const STATO_LABELS = {
  100000000: 'Attiva',
  100000001: 'Inattiva',
  100000002: 'In ristrutturazione'
};

function RsaNode({ data, selected }) {
  return (
    <div
      className={`px-4 py-3 rounded-lg border-2 shadow-md min-w-[180px] transition-all ${
        selected
          ? 'border-blue-600 bg-blue-100 ring-2 ring-blue-300'
          : 'border-blue-400 bg-blue-50 hover:border-blue-500 hover:shadow-lg'
      }`}
    >
      <Handle type="target" position={Position.Left} className="!bg-blue-500" />

      <div className="flex items-center gap-2 mb-1">
        <span className="text-lg">🏥</span>
        <span className="text-xs font-semibold text-blue-600 uppercase tracking-wide">RSA</span>
      </div>

      <div className="font-semibold text-gray-800 text-sm leading-tight">
        {data.nome}
      </div>

      {data.comune && (
        <div className="text-xs text-gray-500 mt-1 flex items-center gap-1">
          <span>📍</span>
          {data.comune}
          {data.provincia && ` (${data.provincia})`}
        </div>
      )}

      {data.stato !== undefined && (
        <div className="mt-2">
          <span className={`inline-block text-xs px-2 py-0.5 rounded-full ${
            data.stato === 100000000
              ? 'bg-green-100 text-green-700'
              : 'bg-gray-100 text-gray-600'
          }`}>
            {STATO_LABELS[data.stato] || 'N/D'}
          </span>
        </div>
      )}

      <Handle type="source" position={Position.Right} className="!bg-blue-500" />
    </div>
  );
}

export default RsaNode;
